let cartQty = 0;

function addToCart() {
  cartQty++;
  document.getElementById('cartCount').textContent = cartQty;

  const t = document.getElementById('toast');
  if (t) {
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 2200);
  }
}


// tanza teacher js

document.querySelectorAll('.thumb').forEach(t => {
  t.addEventListener('click', () => {
    document.querySelectorAll('.thumb').forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  });
});

// qty buttons
document.querySelectorAll('.minus').forEach(btn => {
  btn.addEventListener('click', function () {
    let input = this.nextElementSibling;
    input.value = Math.max(1, +input.value - 1);
  });
});

document.querySelectorAll('.plus').forEach(btn => {
  btn.addEventListener('click', function () {
    let input = this.previousElementSibling;
    input.value = +input.value + 1;
  });
});

// tanza districts js

// Dynamic quantity pricing — contractor will replace this with Shopify variant/tier logic
  const qtyVal = document.getElementById('qty-val');
  const priceDisplay = document.getElementById('price-display');
  const PRICE_STANDARD = 65;
  const PRICE_BULK = 55;
  const BULK_THRESHOLD = 11;

  function updatePrice() {
    const qty = parseInt(qtyVal.value) || 1;
    const unitPrice = qty >= BULK_THRESHOLD ? PRICE_BULK : PRICE_STANDARD;
    const total = qty * unitPrice;
    priceDisplay.textContent = '$' + total.toLocaleString();
  }

  document.getElementById('qty-minus').addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyVal.value) - 1);
    qtyVal.value = v; updatePrice();
  });
  document.getElementById('qty-plus').addEventListener('click', () => {
    qtyVal.value = parseInt(qtyVal.value) + 1; updatePrice();
  });
  qtyVal.addEventListener('input', updatePrice);

  // Thumbnail switching
  document.querySelectorAll('.thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
    });
  });